import _defineProperty from "/codebuild/output/src2417502137/src/node_modules/next/node_modules/@babel/runtime/helpers/esm/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import React, { useContext, useEffect } from "react";
import Head from "next/head";
import NextNProgress from "../components/NextNProgress";
import GoogleFonts from "next-google-fonts";
import CottageSearchMobileHeader from "./Header/CottageSearch/Mobile/Index";
import Header from "./Header";
import Footer from "./Footer";
import { FormProvider } from "./FormContext";
import { BookingProvider } from "./BookingContext";
import dynamic from "next/dynamic";
import MobileHeader from "./Header/Mobile/Index";
import { useRouter } from "next/router";
import { Context } from "../lib/Store";
import * as ga from '../lib/ga';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
var MobileBottomMenu = dynamic(function () {
  return import("./Mobile/Menu/MobileBottomMenu");
}, {
  ssr: false,
  loadableGenerated: {
    webpack: function webpack() {
      return [require.resolveWeak("./Mobile/Menu/MobileBottomMenu")];
    },
    modules: ["../components/Layout.js -> " + "./Mobile/Menu/MobileBottomMenu"]
  }
});
var SvgIcons = dynamic(function () {
  return import("./SvgIcons");
}, {
  ssr: false,
  loadableGenerated: {
    webpack: function webpack() {
      return [require.resolveWeak("./SvgIcons")];
    },
    modules: ["../components/Layout.js -> " + "./SvgIcons"]
  }
});

var Layout = function Layout(pageProps) {
  var router = useRouter();

  var _useContext = useContext(Context),
      state = _useContext[0],
      dispatch = _useContext[1];

  var headerProps = {
    nav: {
      classes: pageProps.nav && pageProps.nav.classes,
      fixed: pageProps.nav && pageProps.nav.fixed,
      color: pageProps.nav && pageProps.nav.color,
      light: pageProps.nav && pageProps.nav.light,
      dark: pageProps.nav && pageProps.nav.dark
    },
    loggedUser: pageProps.loggedUser,
    headerClasses: pageProps.headerClasses,
    showBackButton: pageProps.showBackButton,
    showLogo: pageProps.showLogo,
    showCottageSearch: pageProps.showCottageSearch
  };

  var handleRouteChangeComplete = function handleRouteChangeComplete(url) {
    ga.pageview(url);
    dispatch({
      type: 'route_changed',
      payload: {
        url: url
      }
    });
  };

  useEffect(function () {
    dispatch({
      type: 'route_changed',
      payload: {
        url: router.asPath
      }
    });
    router.events.on('routeChangeComplete', handleRouteChangeComplete);
  });
  return /*#__PURE__*/_jsxs("div", {
    // style={{paddingTop: pageProps.paddingTop ? pageProps.paddingTop : "72px"}}
    style: {
      paddingTop: pageProps.showCottageSearch ? "15px" : "15px"
    },
    className: pageProps.className,
    children: [/*#__PURE__*/_jsx(GoogleFonts, {
      href: "https://fonts.googleapis.com/css2?family=Playfair+Display:wght@700&family=Poppins:ital,wght@0,300;0,400;0,700;1,400&display=swap"
    }), /*#__PURE__*/_jsxs(Head, {
      children: [/*#__PURE__*/_jsxs("title", {
        children: [pageProps.title, " - Cottage Centre vakantiehuizen en campers"]
      }), /*#__PURE__*/_jsx("link", {
        rel: "icon",
        href: "/favicon.ico"
      }), /*#__PURE__*/_jsx("meta", {
        property: "og:image",
        content: "https://www.cottagecentre.nl/logo_social.png"
      }), /*#__PURE__*/_jsx("meta", {
        property: "og:image:alt",
        content: "Cottage Centre vakantiehuizen"
      })]
    }), /*#__PURE__*/_jsx(NextNProgress, {
      color: "#4E66F8",
      options: {
        showSpinner: false
      }
    }), !pageProps.hideHeader && /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx("div", {
        className: "d-none d-lg-block",
        children: /*#__PURE__*/_jsx(Header, _objectSpread({}, headerProps))
      }), /*#__PURE__*/_jsx("div", {
        className: "d-lg-none",
        children: pageProps.showCottageSearch ? /*#__PURE__*/_jsx(CottageSearchMobileHeader, _objectSpread({}, headerProps)) : /*#__PURE__*/_jsx(MobileHeader, _objectSpread({}, headerProps))
      })]
    }), pageProps.listingForm || pageProps.bookingForm ? /*#__PURE__*/_jsxs(React.Fragment, {
      children: [pageProps.listingForm && /*#__PURE__*/_jsx(FormProvider, {
        children: /*#__PURE__*/_jsx("main", {
          children: pageProps.children
        })
      }), pageProps.bookingForm && /*#__PURE__*/_jsx(BookingProvider, {
        children: /*#__PURE__*/_jsx("main", {
          children: pageProps.children
        })
      })]
    }) : /*#__PURE__*/_jsx("main", {
      children: pageProps.children
    }), !pageProps.hideFooter && /*#__PURE__*/_jsx(Footer, {}), !pageProps.hideMobileBottomMenu && /*#__PURE__*/_jsx("div", {
      className: "d-lg-none",
      children: /*#__PURE__*/_jsx(MobileBottomMenu, {})
    }), /*#__PURE__*/_jsx(SvgIcons, {})]
  });
};

export default Layout;